import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Dashboard } from '../containers/Dashboard';
import { Derivative } from '../containers/Derivative';
import { TrackRollup } from '../containers/TrackRollup';
import { CatalogPageLayout } from './CatalogPageLayout';

/**
 * Top-level router combining module-level routers
 */
const Router = () => {
  return (
    <Suspense>
      <Routes>
        <Route element={<CatalogPageLayout />}>
          <Route index element={<Navigate to="territories" replace />} />
          <Route path="territories" element={<Dashboard />} />
          <Route path="derivative" element={<Derivative />} />
          <Route path="rollup" element={<TrackRollup />} />
          <Route path="*" element={<Dashboard />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

Router.displayName = 'CatalogRouter';

export { Router };
